export const formatUrl = (url) => url.split(' ').map(item => item.toLowerCase()).join('-')